import { type ReactElement, useState } from 'react';
import { PageHeader, SearchInput } from '@/shared/ui';
import { UsersTable } from '@/widgets/users-table';

/**
 * 관리자 전용 사용자 목록 페이지 — 검색·페이지 상태만 소유하고 표는 위젯이 담당한다.
 * 셸(헤더 · 사이드바)은 레이아웃 라우트(app/admin-layout)가 제공한다.
 */
export const UsersPage = (): ReactElement => {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');

  return (
    <>
      <PageHeader
        title="회원 관리"
        description="가입한 회원의 계정 상태를 확인하고 차단·해제를 처리합니다. 이메일을 누르면 상세로 갑니다."
        actions={
          <SearchInput
            aria-label="회원 검색"
            placeholder="이메일 또는 이름 검색"
            value={search}
            onChange={(event) => {
              setSearch(event.target.value);
              setPage(1);
            }}
          />
        }
      />

      <UsersTable page={page} search={search} onPageChange={setPage} />
    </>
  );
};
